import React from 'react';

// Components
import ConfirmModal from '../ConfirmModal/ConfirmModal';

type Props = {
  isOpen: boolean;
  onToggle: () => void;
  handleDelete: Function;
};

const DeleteReviewTemplateModal = ({ isOpen, onToggle, handleDelete }: Props) => {
  const onConfirmClick = () => {
    handleDelete();
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      onToggle={onToggle}
      onConfirmClick={onConfirmClick}
      title="Delete template?"
      message="Are you sure you want to delete this template?"
    />
  );
};

export default DeleteReviewTemplateModal;
